// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/login_background_image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.login-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
}

/* Sign-in card styling */
.sign-in-card {
  width: 40vw;
  height: 100vh;
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
}

.sign-in-header {
  text-align: center;
}

.sign-in-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1a202c;
  letter-spacing: -0.025em;
  margin-bottom: 1rem !important;
}

.sign-in-subtitle {
  font-size: 1rem;
  color: #718096;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  margin-bottom: 2rem !important;
}

.sign-in-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  width: 100%;
}

.sign-in-button {
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.25);
  text-transform: none;
  letter-spacing: 0.5px;
}

.sign-in-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.35);
  background: linear-gradient(135deg, #5a6fd8 0%, #6b4190 100%);
}

.sign-in-button:active {
  transform: translateY(-1px);
}

.sign-in-footer {
  text-align: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.footer-text {
  font-size: 0.9rem;
  color: #718096;
  line-height: 1.6;
  margin: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .login-page {
    padding: 1rem;
    justify-content: center;
  }
  
  .sign-in-card {
    width: 65%;
    height: auto;
    border-radius: 1rem;
    padding: 2.5rem;
    justify-content: flex-start;
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  
  .sign-in-title {
    font-size: 1.75rem;
  }
  
  .sign-in-button {
    width: 100%;
    max-width: 280px;
  }
}

@media (max-width: 480px) {
  .sign-in-card {
    width: 100%;
    padding: 2rem;
    border-radius: 1rem;
  }
  
  .sign-in-title {
    font-size: 1.5rem;
  }
  
  .sign-in-button {
    width: 100%;
  }
}

.registration-links{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/authentication.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yDAA6D;EAC7D,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gDAAgD;EAChD,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".app-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.login-page {\n  background-image: url('../public/login_background_image.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0;\n}\n\n/* Sign-in card styling */\n.sign-in-card {\n  width: 40vw;\n  height: 100vh;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  justify-content: center;\n  align-items: center;\n}\n\n.sign-in-header {\n  text-align: center;\n}\n\n.sign-in-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1a202c;\n  letter-spacing: -0.025em;\n  margin-bottom: 1rem !important;\n}\n\n.sign-in-subtitle {\n  font-size: 1rem;\n  color: #718096;\n  font-weight: 400;\n  line-height: 1.5;\n  margin: 0;\n  margin-bottom: 2rem !important;\n}\n\n.sign-in-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  align-items: center;\n  width: 100%;\n}\n\n.sign-in-button {\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.25);\n  text-transform: none;\n  letter-spacing: 0.5px;\n}\n\n.sign-in-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.35);\n  background: linear-gradient(135deg, #5a6fd8 0%, #6b4190 100%);\n}\n\n.sign-in-button:active {\n  transform: translateY(-1px);\n}\n\n.sign-in-footer {\n  text-align: center;\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.footer-text {\n  font-size: 0.9rem;\n  color: #718096;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .login-page {\n    padding: 1rem;\n    justify-content: center;\n  }\n  \n  .sign-in-card {\n    width: 65%;\n    height: auto;\n    border-radius: 1rem;\n    padding: 2.5rem;\n    justify-content: flex-start;\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  \n  .sign-in-title {\n    font-size: 1.75rem;\n  }\n  \n  .sign-in-button {\n    width: 100%;\n    max-width: 280px;\n  }\n}\n\n@media (max-width: 480px) {\n  .sign-in-card {\n    width: 100%;\n    padding: 2rem;\n    border-radius: 1rem;\n  }\n  \n  .sign-in-title {\n    font-size: 1.5rem;\n  }\n  \n  .sign-in-button {\n    width: 100%;\n  }\n}\n\n.registration-links{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
